import sal from 'sal.js'

const browserWidth = document.body.offsetWidth;
const DESKTOP_BREAKPOINT = 992;

export default function () {
  document.addEventListener('alpine:init', () => {
    document.addEventListener("DOMContentLoaded", function() {
      const scrollAnimations = sal({
        root: null,
        once: true,
      });

      if (browserWidth < DESKTOP_BREAKPOINT) {
        scrollAnimations.disable();
      }

      window.addEventListener("resize", () => {
        if (browserWidth < DESKTOP_BREAKPOINT) {
          scrollAnimations.disable();
        } else {
          scrollAnimations.enable();
        }
      });
    });
  });
}
